import { ISpinnerProps, Spinner } from '@pinpointhq/thumbtack';
import * as React from 'react';

export interface ILoadingSpinnerProps extends ISpinnerProps {
  /**
   * The height of the loading spinner container
   */
  height?: string;
  justifyContent?: 'center' | 'flex-start';
  /**
   * The minimum width of the loading spinner container
   */
  // minWidth?: string;
  /**
   * The width of the loading spinner container as the container is a block
   * @default 100%
   */
  width?: string;
}

export function LoadingSpinner({ height, justifyContent, width, ...spinnerProps }: ILoadingSpinnerProps) {
  const style: React.CSSProperties = {
    alignItems: 'center',
    display: 'flex',
    height: height || '120px',
    justifyContent: justifyContent || 'center',
    width: width || '100%',
  };
  return (
    <div style={style}>
      <Spinner {...spinnerProps} />
    </div>
  );
}

export default LoadingSpinner;
